import { ApiResponse } from '../types';
import {
  Task,
  TaskQueryParams,
  TaskListResponse,
  UpdateTaskDto,
  TaskTypeOption
} from '../types/task';
import { http, buildUrl } from './base';

/**
 * 任务管理相关 API 服务
 */
export class TaskService {
  /**
   * 获取任务列表
   */
  static async getTaskList(params?: TaskQueryParams): Promise<ApiResponse<TaskListResponse>> {
    const url = buildUrl('/tasks');
    return http.get(url, params);
  }

  /**
   * 获取任务详情
   */
  static async getTaskDetail(id: number): Promise<ApiResponse<Task>> {
    const url = buildUrl(`/tasks/${id}`);
    return http.get(url);
  }

  /**
   * 更新任务
   */
  static async updateTask(id: number, data: UpdateTaskDto): Promise<ApiResponse<Task>> {
    const url = buildUrl(`/tasks/${id}`);
    return http.patch(url, data);
  }

  /**
   * 删除任务
   */
  static async deleteTask(id: number): Promise<ApiResponse<void>> {
    const url = buildUrl(`/tasks/${id}`);
    return http.delete(url);
  }

  /**
   * 获取任务类型列表
   */
  static async getTaskTypeList(): Promise<ApiResponse<{
    types: TaskTypeOption[];
  }>> {
    const url = buildUrl('/tasks/type-list');
    return http.get(url);
  }
}

export default TaskService;
